/*--------------------------------------------------------------
# Import Styles Easepick
--------------------------------------------------------------*/

import css_picker from 'easepick/bundle/dist/index.css?raw';
import css_picker_custom from './../../../../scss/components/datepicker/_date-picker-dropdown.scss?inline';

export const styles = css_picker + css_picker_custom;
